import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import AskYelo from '../components/AskYelo';

/**
 * AI Assistant - "Ask Yelo" on a page of its own (owner, 5 Oct 2026: "ازاى ادى صلاحية المساعد الذكي لحد من غير ما يظهر
 * باقى الأوفر فيو ؟"): opened by the AI Assistant permission (ask_assistant) alone - the Overview's figures stay with
 * view_dashboard. The same box as on the Home page.
 */
export default function AssistantPage() {
    useEffect(() => {
        document.title = 'AI Assistant · Yelo Dubai';
    }, []);
    return (
        <Layout title="AI Assistant" subtitle="Find a customer by phone, Emirates ID, name or contract - or ask the assistant">
            <AskYelo />
        </Layout>
    );
}
